// Configuration from environment variables
const API_URL = import.meta.env.VITE_DEV_API_URL || 'https://vchd-back.lservice.uz/api';
const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL || 'wss://vchd-back.lservice.uz';

// Development overrides (optional)
const DEV_API_URL = import.meta.env.VITE_DEV_API_URL;
const DEV_WEBSOCKET_URL = import.meta.env.VITE_DEV_WEBSOCKET_URL;

// Use development URLs if in development mode and they are provided
const isDevelopment = import.meta.env.DEV;
const finalApiUrl = isDevelopment && DEV_API_URL ? DEV_API_URL : API_URL;
const finalWebsocketUrl = isDevelopment && DEV_WEBSOCKET_URL ? DEV_WEBSOCKET_URL : WEBSOCKET_URL;

export { finalApiUrl as API_URL, finalWebsocketUrl as WEBSOCKET_URL };
